/* Waïloa – compléments fiche produit (chargé en fin de page par snippets/wl-foot-pdp, fiches produits uniquement)
   1. Barre d'achat : le thème découpe chaque lettre du vrai bouton dans un <span> ; wl-pdp.js en recopiait le texte avec des
      espaces entre chaque lettre (« A J O U T E R… »). On recolle les lettres (espaces conservés) à chaque mise à jour.
   2. Note sous le titre : défilement doux jusqu'aux avis (#wl-avis). */
(function () {
  function label() {
    var btn = document.querySelector('.wl-pdp-main form.main-product-form [data-atc-wrapper]');
    if (!btn) return '';
    var tx = btn.querySelector('[data-atc-button-text]') || btn;
    var t = tx.children.length ? [].map.call(tx.children, function (s) { return s.textContent; }).join('') : tx.textContent;
    return t.replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }
  function squash(s) { return String(s || '').replace(/\s+/g, ''); }
  function fix() {
    var b = document.querySelector('[data-wl-sticky-btn]');
    if (!b) return;
    var cur = b.textContent, good = label();
    /* Seulement si le texte affiché est le libellé du bouton « éclaté » lettre par lettre (le libellé « Choisir ma taille » reste intact) */
    if (good && cur !== good && squash(cur) === squash(good)) b.textContent = good;
  }
  function init() {
    fix();
    var b = document.querySelector('[data-wl-sticky-btn]');
    if (b && window.MutationObserver) new MutationObserver(fix).observe(b, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* Waïloa – note sous le titre : défilement doux jusqu'aux avis (#wl-avis) */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-wl-rate]');
    if (!a) return;
    var t = document.getElementById('wl-avis');
    if (!t) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#wl-avis');
  });
})();